export default __webpack_public_path__ + "img/estimating-scorecard.fe2f80.svg";